import InsuredCreatedEvent from '@/domains/insureds/events/InsuredCreatedEvent';

const InsuredEvents = {
  Created: InsuredCreatedEvent,
};

export default InsuredEvents;
